import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const OBJECT_SHUFFLE_ACTIVITY_FRAGMENT = gql `
  fragment ObjectShuffleActivityFragment on ObjectShuffleActivity {
    targetKey
    rounds {
      letter
      optionalLabel
      answerImage {
        image {
          ...AssetFragment
        }
      }
      activityAudio: optionalAudio {
        audio {
          ...AssetFragment
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default OBJECT_SHUFFLE_ACTIVITY_FRAGMENT;
